export default {"src":"/_next/static/media/team-background.b1ea909b.svg","height":1044,"width":1440,"blurWidth":0,"blurHeight":0};